import SEOHead from "@/components/SEOHead";
import { COMPANY } from "@/data/content";

export default function ImpressumPage() {
  return (
    <>
      <SEOHead
        title={`Impressum – ${COMPANY.name}`}
        description={`Impressum von ${COMPANY.legalName}. Anbieterkennzeichnung gemäß § 5 TMG und § 55 RStV.`}
      />
      <section className="pt-32 pb-24 bg-white">
        <div className="max-w-[900px] mx-auto px-6 md:px-12" data-testid="impressum-page">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-3">Rechtliches</p>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0C2749]" style={{ fontFamily: "Outfit" }}>
            Impressum
          </h1>
          <p className="text-sm text-slate-500 mt-3">Angaben gemäß § 5 TMG</p>

          <div className="mt-10 space-y-10 text-[#0C2749]">

            <Section title="Anbieter">
              <p className="font-medium">{COMPANY.legalName}</p>
              <p>{COMPANY.street}</p>
              <p>{COMPANY.postal} {COMPANY.city}</p>
              <p>Deutschland</p>
            </Section>

            <Section title="Kontakt">
              <p>Telefon: <a href={`tel:${COMPANY.phoneRaw}`} className="text-[#2873B8] hover:underline">{COMPANY.phone}</a></p>
              <p>E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#2873B8] hover:underline">{COMPANY.email}</a></p>
              <p>Web: <a href={`https://${COMPANY.website}`} className="text-[#2873B8] hover:underline">{COMPANY.website}</a></p>
            </Section>

            <Section title="Vertreten durch">
              <p>Mark Sturm</p>
            </Section>

            <Section title="Registereintrag">
              <p>Eingetragen im Handelsregister.</p>
              <p>Registergericht: Amtsgericht Düsseldorf</p>
              <p>Registernummer: HRB 98434</p>
            </Section>

            <Section title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
              <p>Mark Sturm</p>
              <p>{COMPANY.legalName}</p>
              <p>{COMPANY.street}, {COMPANY.postal} {COMPANY.city}</p>
            </Section>

            <Section title="Berufshaftpflichtversicherung">
              <p>Bauleistungs-, Bauwesen- und Betriebshaftpflichtversicherung vorhanden.</p>
              <p className="text-sm text-slate-500">Name und Sitz des Versicherers werden auf Anfrage offengelegt.</p>
            </Section>

            <Section title="EU-Streitschlichtung">
              <p className="text-sm text-slate-600 leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#2873B8] hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                . Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </Section>

            <Section title="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
              <p className="text-sm text-slate-600 leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </Section>

            <Section title="Haftung für Inhalte">
              <p className="text-sm text-slate-600 leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
                allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch
                nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-sm text-slate-600 leading-relaxed mt-3">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
                Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt
                der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechts­verletzungen
                werden wir diese Inhalte umgehend entfernen.
              </p>
            </Section>

            <Section title="Haftung für Links">
              <p className="text-sm text-slate-600 leading-relaxed">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss
                haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte
                der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
                Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>
            </Section>

            <Section title="Urheberrecht">
              <p className="text-sm text-slate-600 leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem
                deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
                außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
                Autors bzw. Erstellers.
              </p>
            </Section>

            <Section title="Bildnachweise">
              <p className="text-sm text-slate-600 leading-relaxed">
                Verwendete Bilder stammen u. a. von Unsplash und Pexels (lizenzfrei zur kommerziellen Nutzung)
                sowie aus dem eigenen Projekt-Portfolio von {COMPANY.legalName}.
              </p>
            </Section>

          </div>
        </div>
      </section>
    </>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-lg md:text-xl font-semibold mb-3" style={{ fontFamily: "Outfit" }}>
        {title}
      </h2>
      <div className="space-y-1 text-[15px] leading-relaxed">{children}</div>
    </div>
  );
}
